export default { 
  PublicBeranda: require('./PublicBeranda').default,
  PublicDetail: require('./PublicDetail').default,
  PublicPrakerja: require('./PublicPrakerja').default,

}